let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let HorizontalFieldSpot = require("react-loose-forms.bootstrap3/layouts/HorizontalFieldSpot");

let EIDForm = dd.createClass({
	mixins: [FormMixin],
	buildSchema(){
		return  {
			eid: {
				label: "Event ID",
				type: "text",
				validate(v){
					return esUtils.toInt(v) > 0 || "Please enter a valid event id.";
				}
			}
		};
	},
	render(){
		return dd.form({className: "form-horizontal", onSubmit: this.Form_onSubmit},
			ezHorizontalFields(this),
			dd.br(),
			HorizontalFieldSpot(null, FormButtons({
				right_align: true,
				submit_btn_text: "Attach",
				cancel_btn_text: "Cancel",
				onCancel: this.props.onClose
			}))
		);
	}
});

module.exports = dd.createClass({
	mixins: [RadioServiceMixin],
	RadioService_setup(){
		return {
			Event_change_parentID: {
				key: "callService",
				on: {
					succeeded(){
						radio("reload_Event").broadcast(this.props.event.eid);
						this.props.onClose();
					}
				}
			}
		};
	},
	__onSubmit(data){
		this.RadioService_callService("Event_change_parentID", {
			eid: esUtils.toInt(data.eid),
			parentID: this.props.event.eid
		});
	},
	render(){
		let ajax = this.state.Event_change_parentID;
		let {onClose} = this.props;

		if(ajax.waiting){
			return Modal({title: "Attaching...", buttons: []},
				LoadingWrap({is_loading: true, text: "Attaching..."})
			);
		}

		return Modal({
				title: "Attach existing event as child...",
				buttons: [],
				onClose
			},
			ErrorAlert({message: ajax.error}),
			dd.p(null,
				"Enter the event ID you wish to attach as a child to this event."
			),
			EIDForm({onSubmit: this.__onSubmit, onClose})
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/ParentChildControls/AttachExistingChildModal.js